import { useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { toast } from "sonner"
import Flex from "@/components/flex"
import HeaderWrapperDesktop from "../header-wrapper-desktop"
import DropdownDong from "../_parts/dropdown-dong"
import DropdownHo from "../_parts/dropdown-ho"
import { unitsStore } from "@/routes/apt/[apt_code]/units/units-store"
import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import AptHeaderContent from "../apt-header-content"
import SearchButton from "@/components/buttons/search-button"
import { headerBundle } from "./units-header-const"

const UnitsHeaderDesktop = ({ position = "sticky" }) => {
  const { lang } = langStore()
  const [searchParams, setSearchParams] = useSearchParams()

  const currentResource = searchParams.get("resource") || "water"
  const { draftDong, setDraftDong, draftHo, setDraftHo } = unitsStore()
  const { originDongs, dongHo, unitStatusMap } = unitsStore()

  const dongOptions = useMemo(() => {
    return originDongs
      .map((d) => ({
        id: d,
        label: formatMessage(headerBundle.dong[lang], { dong: +d })
      }))
      .sort((a, b) => Number(a.id) - Number(b.id))
  }, [originDongs, lang])

  const hoOptions = useMemo(() => {
    if (!dongHo[draftDong]) return []
    return dongHo[draftDong].map((ho) => ({
      id: ho,
      label: formatMessage(headerBundle.ho[lang], { ho }),
      badges: unitStatusMap?.[draftDong]?.hos?.[ho]?.badges || []
    }))
  }, [dongHo, draftDong, unitStatusMap, lang])

  const dongChange = (dong) => {
    setDraftDong(dong)
    setDraftHo("")
  }

  const search = () => {
    if (!draftDong) return toast.error(headerBundle.alert.dongFirst[lang])
    if (!draftHo) return toast.error(headerBundle.alert.hoFirst[lang])

    const next = new URLSearchParams(searchParams)
    next.set("dong", draftDong)
    next.set("ho", draftHo)
    if (!searchParams.get("resource")) next.set("resource", "water")
    setSearchParams(next)
  }

  return (
    <HeaderWrapperDesktop position={position} useRight={false}>
      <AptHeaderContent label={headerBundle.title[lang]}>
        <Flex className="ml-auto items-center" gap={4}>
          <DropdownDong
            options={dongOptions}
            value={draftDong}
            onChange={dongChange}
            placeholder={headerBundle.select.dong[lang]}
            unitStatusMap={unitStatusMap}
            currentResource={currentResource}
          />

          <DropdownHo
            options={hoOptions}
            value={draftHo}
            onChange={setDraftHo}
            placeholder={headerBundle.select.ho[lang]}
            disabled={!draftDong}
            prevent={() => !draftDong && toast.error(headerBundle.alert.dongFirst[lang])}
            currentResource={currentResource}
          />
          <SearchButton onClick={search} label={headerBundle.search[lang]} />
        </Flex>
      </AptHeaderContent>
    </HeaderWrapperDesktop>
  )
}

export default UnitsHeaderDesktop
